import { Injectable } from '@angular/core';
import { ApmService } from '@elastic/apm-rum-angular';
@Injectable({
  providedIn: 'root',
})
export class IndexDbService {
  constructor(private Errservice: ApmService) {}

  sendIndexDbError(dbname: string, error: Error) {
    this.Errservice.apm.setCustomContext({ dbname, error } as any);
  }
}
